
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1bi5g_14zql_5",
  "token-trigger": "awsui_token-trigger_1bi5g_14zql_9",
  "token-list": "awsui_token-list_1bi5g_14zql_13",
  "token-list-item": "awsui_token-list-item_1bi5g_14zql_17",
  "token-overflow-pill": "awsui_token-overflow-pill_1bi5g_14zql_21"
};
  